// extracted by mini-css-extract-plugin
export default {"option":"checkbox-option_option__ZF52n"};